var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UniqueUserId } from '@xylabs/pixel';
import { getStoredQueryStringValue } from '../../lib';
import { ContactInfoWrapper } from '../../wrappers';
import { Cart, CartItemSlot } from '../useCart';
import CoinUserEventHandlerBase from './CoinUserEventHandlerBase';
import GoogleEvents from './Google';
import TestData from './TestData';
class GoogleEventHandler extends CoinUserEventHandlerBase {
    constructor() {
        super(...arguments);
        this.events = new GoogleEvents();
    }
    pageView(url) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.pageView(url);
        });
    }
    emailCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.emailCollected().send(this.buildCustomProperties(fields));
        });
    }
    accountCreated() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.accountCreated().send(this.buildCustomProperties());
        });
    }
    shareCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.shareCompleted().send(this.buildCustomProperties());
        });
    }
    buyticketsCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.buyticketsCompleted().send(this.buildCustomProperties());
        });
    }
    installCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.installCompleted().send(this.buildCustomProperties());
        });
    }
    funnelCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.funnelCompleted().send(this.buildCustomProperties());
        });
    }
    offerRequested(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.offerRequested().send(this.buildCustomProperties(fields));
        });
    }
    feedbackScoreCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.feedbackScoreCollected().send(this.buildCustomProperties(fields));
        });
    }
    feedbackSourceCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.feedbackSourceCollected().send(this.buildCustomProperties(fields));
        });
    }
    goodFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.goodFeedbackRequested().send(this.buildCustomProperties());
        });
    }
    badFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.badFeedbackRequested().send(this.buildCustomProperties());
        });
    }
    contactInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            const contactInfo = new ContactInfoWrapper().load();
            yield this.events
                .contactInfoComplete()
                .send(this.buildCartProperties(contactInfo.getSanitizedData()));
        });
    }
    addressInfoComplete(addressInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events
                .addressInfoComplete()
                .send(this.buildCartProperties(Object.assign({}, addressInfo)));
        });
    }
    paymentInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.paymentInfoComplete().send(this.buildCartProperties());
        });
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.addToCart().send(this.buildCartProperties());
        });
    }
    purchaseCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.events.purchase().send(this.buildCartProperties()),
                this.events.transactionCompleted().send(this.buildCartProperties()),
            ]);
        });
    }
    userClick(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.userClick().send(fields);
        });
    }
    initiateCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.beginCheckout().send(this.buildCartProperties());
        });
    }
    purchaseAttempted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.transactionAttempted().send(this.buildCartProperties());
        });
    }
    purchaseFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.transactionFailed().send(this.buildCartProperties());
        });
    }
    upsellViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellViewed().send(this.buildCustomProperties());
        });
    }
    upsellUnavailable() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellUnavailable().send(this.buildCustomProperties());
        });
    }
    upsellAccepted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellAccepted().send(this.buildCustomProperties());
        });
    }
    trialStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.trialStarted().send(this.buildCustomProperties());
        });
    }
    funnelStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.funnelStarted().send(this.buildCustomProperties());
        });
    }
    upsellSucceeded() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.events.purchase().send(this.buildCartProperties()),
                this.events.upsellSucceeded().send(this.buildCartProperties()),
            ]);
        });
    }
    upsellFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellFailed().send(this.buildCustomProperties());
        });
    }
    testStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.testStarted().send(this.buildCustomProperties());
        });
    }
    viewContent(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.viewContent().send(this.buildCustomProperties(fields));
        });
    }
    buildCartProperties(data) {
        var _a, _b;
        const items = [];
        const cart = Cart.get();
        for (const item of (_a = cart === null || cart === void 0 ? void 0 : cart.getItems()) !== null && _a !== void 0 ? _a : []) {
            items.push({
                currency: 'USD',
                google_business_vertical: 'retail',
                id: item.planId,
                item_id: item.planId,
                item_name: (_b = item.title) !== null && _b !== void 0 ? _b : item.planId,
                price: item.price,
                quantity: 1,
            });
        }
        return Object.assign(Object.assign(Object.assign({}, data), this.buildValueProperties(data)), { items });
    }
    buildUpsellProperties(data) {
        var _a, _b;
        const items = [];
        const item = Cart.get().getItemsBySlot(CartItemSlot.Upsell);
        if (item) {
            items.push({
                currency: 'USD',
                google_business_vertical: 'retail',
                id: item.planId,
                item_id: item.planId,
                item_name: (_a = item.title) !== null && _a !== void 0 ? _a : item.planId,
                price: item.price,
                quantity: 1,
            });
        }
        return Object.assign(Object.assign({}, data), { currency: 'USD', items, value: (_b = item === null || item === void 0 ? void 0 : item.value) !== null && _b !== void 0 ? _b : 0 });
    }
    buildValueProperties(data) {
        const cart = Cart.get();
        return Object.assign(Object.assign(Object.assign({}, data), this.buildCustomProperties(data)), { currency: 'USD', value: cart.getValue() });
    }
    buildCustomProperties(data) {
        const cart = Cart.get();
        const coinId = new UniqueUserId().id;
        const testData = new TestData().data;
        const tuneTransactionId = getStoredQueryStringValue('tune_transaction_id');
        return Object.assign(Object.assign({}, data), { coinId, itemSet: cart.getItemSet(), testData, tuneTransactionId: tuneTransactionId !== null && tuneTransactionId !== void 0 ? tuneTransactionId : undefined });
    }
}
export default GoogleEventHandler;
//# sourceMappingURL=GoogleEventHandler.js.map